import { render, staticRenderFns } from "./AccountingTabs.vue?vue&type=template&id=9cfaa8ea&scoped=true"
import script from "./AccountingTabs.vue?vue&type=script&lang=js"
export * from "./AccountingTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfaa8ea",
  null
  
)

export default component.exports